import compact from 'lodash/compact';
import { historySingleton } from 'src/client/history';
import { storeSingleton } from 'src/client/store/storeSingleton';
import url from 'url';
import { IN_APP_REDIRECT } from '../../constants/queryParams';
import { getGuideItemSubscribeSuccessRedirectLink } from '../../utils/guideItem/getGuideItemPathname';
import getGuideItemProducts from '../../utils/guideItem/getGuideItemProducts';
import createSubscribeLink from '../../utils/subscription/createSubscribeLink';
import { preloadStripeJs } from '../../utils/subscription/preloadStripeJs';
import shouldUseStripe from '../../utils/subscription/shouldUseStripe';

/**
 * Opens the subscribe page for a guide item. It navigates in the app, so playback keeps going and
 * Stripe.js, started here, loads alongside the page.
 *
 * `fullPageLoad` is for clicks that also play: a play click's own navigation, like the
 * `history.replace(to)` in withSyncedPlayerBehavior, would overwrite an in-app one.
 */
const createAndOpenSubscribeLink = (
  guideItem,
  location,
  products,
  source,
  { fullPageLoad = false } = {},
) => {
  const subscribeSuccessRedirectLink = getGuideItemSubscribeSuccessRedirectLink(guideItem);
  const additionalParams = {
    sku: compact(products || getGuideItemProducts(guideItem)),
    ...(subscribeSuccessRedirectLink && {
      [IN_APP_REDIRECT]: subscribeSuccessRedirectLink,
    }),
  };

  const subscribeLink = url.format(
    createSubscribeLink({
      source: source || location?.query?.source,
      guideId: guideItem?.guideId,
      location,
      additionalParams,
    }),
  );

  // TODO: drop `fullPageLoad` once withSyncedPlayerBehavior no longer calls history.replace(to),
  // or is deleted altogether.
  if (fullPageLoad) {
    window.open(subscribeLink, '_self');
    return;
  }

  if (shouldUseStripe(storeSingleton.state)) {
    preloadStripeJs();
  }

  historySingleton.push(subscribeLink);
};

export default createAndOpenSubscribeLink;
